/* ═══════════════════════════════════════════════════════════════
   TG BRAND MIGRATION — Header JS
   Scroll-state toggle + mega menu hover
   Nav and sub-nav are now Liquid — no DOM injection needed
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var header = document.querySelector('.section-header');
  if (!header) return;

  /* ── Scroll detection ─────────────────────────────────────── */
  var announceH = 0;

  function getAnnounceH() {
    var bar = document.querySelector('.section-announcement-bar');
    return bar ? bar.offsetHeight : 0;
  }

  function onScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    header.classList.toggle('tg-scrolled', y > 40);
    if (announceH > 0) {
      header.style.top = y >= announceH ? '0px' : (announceH - y) + 'px';
    } else {
      header.style.top = '';
    }
  }

  function initScroll() {
    announceH = getAnnounceH();
    if (announceH > 0) header.style.top = announceH + 'px';
    onScroll();
  }

  if (!header.dataset.tgScrollBound) {
    window.addEventListener('scroll', onScroll, { passive: true });
    header.dataset.tgScrollBound = '1';
  }
  /* Run as early as possible to prevent flash of header above announcement bar,
     then re-run on load in case marquee/dynamic content shifts bar height */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScroll);
    window.addEventListener('load', initScroll);
  } else {
    initScroll();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', initScroll);
    }
  }

  /* ResizeObserver: re-measure if announcement bar height changes after init
     (covers marquee/ticker content that settles after DOMContentLoaded) */
  function watchAnnounceBar() {
    var bar = document.querySelector('.section-announcement-bar');
    if (!bar || !window.ResizeObserver) return;
    new ResizeObserver(function () {
      announceH = getAnnounceH();
      onScroll();
    }).observe(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAnnounceBar);
  } else {
    watchAnnounceBar();
  }

  /* ── Mega menu hover ──────────────────────────────────────── */
  var closeTimer = null;

  function openPanel(key) {
    clearTimeout(closeTimer);
    header.querySelectorAll('.tg-mega-panel').forEach(function (p) {
      var isTarget = p.dataset.panelKey === key;
      p.classList.toggle('is-open', isTarget);
      p.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
    });
    header.querySelectorAll('.tg-nav-item .header__nav-link').forEach(function (a) {
      a.classList.toggle('tg-active', a.closest('.tg-nav-item').dataset.navKey === key);
    });
  }

  function scheduleClose() {
    closeTimer = setTimeout(function () {
      header.querySelectorAll('.tg-mega-panel').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      header.querySelectorAll('.header__nav-link.tg-active').forEach(function (a) {
        a.classList.remove('tg-active');
      });
    }, 200);
  }

  function bindNavItems() {
    header.querySelectorAll('.tg-nav-item[data-has-dropdown="true"]').forEach(function (item) {
      var key = item.dataset.navKey;
      item.addEventListener('mouseenter', function () { openPanel(key); });
      item.addEventListener('mouseleave', scheduleClose);
      var panel = header.querySelector('.tg-mega-panel[data-panel-key="' + key + '"]');
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  /* ── Sub-nav dropdowns ────────────────────────────────────── */
  var subCloseTimer = null;

  function openSubPanel(key) {
    clearTimeout(subCloseTimer);
    header.querySelectorAll('.tg-sub-dropdown').forEach(function (p) {
      var isTarget = p.dataset.subPanel === key;
      p.classList.toggle('is-open', isTarget);
      p.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
    });
  }

  function scheduleSubClose() {
    subCloseTimer = setTimeout(function () {
      header.querySelectorAll('.tg-sub-dropdown').forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
    }, 200);
  }

  function bindSubNavItems() {
    /* The dropdown is a child of the <li>, so mouseleave on the <li>
       only fires when the cursor exits both the link AND the dropdown. */
    header.querySelectorAll('.tg-sub-nav__item.has-dropdown').forEach(function (item) {
      var key = item.dataset.subKey;
      item.addEventListener('mouseenter', function () { openSubPanel(key); });
      item.addEventListener('mouseleave', scheduleSubClose);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindNavItems();
      bindSubNavItems();
    });
  } else {
    bindNavItems();
    bindSubNavItems();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('section-header')) {
      bindNavItems();
      bindSubNavItems();
    }
  });
})();
